import { systemEngineEnvironment } from "services/environment/systemEngine";

import { SqlRbacAction } from "./action";
import { Privilege, PrivilegeObjectType } from "./types";

export const getOwnedOrgObjectsPrivileges = async (loginName: string) => {
  const sql = `
select account_name as object_name, '${PrivilegeObjectType.account}' AS object_type, '${SqlRbacAction.USAGE}' AS privilege_type, account_owner as owner from information_schema.accounts
union
select login_name as object_name, '${PrivilegeObjectType.login}' as object_type, '${SqlRbacAction.USAGE}' AS privilege_type, login_owner as owner from information_schema.logins
union
select service_account_name as object_name, '${PrivilegeObjectType.service_account}' as object_type, '${SqlRbacAction.USAGE}' AS privilege_type, service_account_owner as owner from information_schema.service_accounts
union
select network_policy_name as object_name, '${PrivilegeObjectType.network_policy}' as object_type, '${SqlRbacAction.USAGE}' AS privilege_type, network_policy_owner as owner from information_schema.network_policies
union
select role_name as object_name, '${PrivilegeObjectType.organization_role}' as object_type, '${SqlRbacAction.USAGE}' AS privilege_type, role_owner as owner from org_db.information_schema.enabled_roles
`;

  const result = await systemEngineEnvironment.execute<Privilege>(sql);

  const [response] = result;

  response.rows.map(row => {
    if (row?.owner === loginName) {
      return {
        ...row,
        privilege_type: SqlRbacAction.MODIFY,
      };
    }

    return row;
  });

  return response.rows;
};
